// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"364":"445042bde4276243","468":"698b73e89b90ecbd","678":"69eb5556f2783fe3"}[chunkId] + ".js";
};